














import { Config } from "../utils/Config";
import InputField from "../core/Forms/InputField.vue";
import Multiselect from "vue-multiselect";
import { Contact } from "../models/Contact";

export default {
    name: "ContactTagEdit",
    components: { InputField, Multiselect },
    props: {
        contactData: Object,
    },
    data() {
        return {
            contact: null,
            selected_tags: [],
            options: [],
            vueMultiselectParams: Config.vueMultiselectParams,
        };
    },
    created() {
        this.options = _.toArray(Contact.Tag);
    },
    watch: {
        contactData: {
            immediate: true,
            handler: function () {
                if (!this.contactData) {
                    return;
                }
                this.contact = new Contact(this.contactData);
                this.selected_tags = this.contact.tagsDisplay;
            },
        },
        "contact.tags": function () {
            if (!_.isEqual(this.contact.tagsDisplay, this.selected_tags)) {
                this.selected_tags = this.contact.tagsDisplay;
            }
        },
        selected_tags: function () {
            this.contact.tags = _.map(this.selected_tags, "id");
            this.$emit("updated-tags", this.contact.tags);
        },
    },
};
